import { render, staticRenderFns } from "./DocumentOverview.vue?vue&type=template&id=3dfc18ab&scoped=true&"
import script from "./DocumentOverview.vue?vue&type=script&lang=js&"
export * from "./DocumentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc18ab",
  null
  
)

export default component.exports